import { FC, useCallback } from 'react';
import { useField, useForm } from 'react-final-form';

import { FormBuildingSelect } from 'src/components/BuildingSelect/FormBuildingSelect';
import { FormCheckbox } from 'src/components/FormCheckbox/FormCheckbox';
import { FormTextArea } from 'src/components/FormTextArea/FormTextArea';
import { FormTextField } from 'src/components/FormTextField/FormTextField';
import { Section } from 'src/components/Section/Section';
import { FormTownSelect } from 'src/components/TownSelect/FormTownSelect';
import { TownSelectItem } from 'src/components/TownSelect/TownSelect';

export const AdministratorFloorFields: FC = () => {
  const { change } = useForm();
  const locationDisabled = !!useField<number | undefined>('id').input.value;
  const enabled = useField<boolean>('enabled').input.value;
  const town = useField<TownSelectItem | undefined>('town').input.value;

  const handleChangeTown = useCallback(() => {
    change('building', undefined);
  }, [change]);

  return (
    <>
      <Section
        title={locationDisabled ? 'Город' : 'Выберите город'}
        testId='administratorTown'
      >
        <FormTownSelect
          name='town'
          dataTestId='administratorTownSelect'
          onChange={handleChangeTown}
          disabled={locationDisabled}
        />
      </Section>
      <Section
        title={locationDisabled ? 'Офис' : 'Выберите офис'}
        testId='administratorBuilding'
      >
        <FormBuildingSelect
          name='building'
          dataTestId='administratorBuildingSelect'
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          townId={town?.value?.townId}
          disabled={locationDisabled || !town}
        />
      </Section>
      <Section title='Укажите номер' testId='administratorFloorTitle'>
        <FormTextField
          name='title'
          size='medium'
          label='Номер'
          dataTestId='administratorFloorTitleField'
          required
          fullWidth
        />
      </Section>
      <Section title='Выберите доступность' testId='administratorFloorEnabled'>
        <FormCheckbox
          name='enabled'
          label='Доступно пользователям'
          dataTestId='administratorFloorEnabledCheckbox'
        />
        <FormTextArea
          name='disabledReason'
          disabled={enabled}
          placeholder='Опишите причину недоступности'
          fullWidth
        />
      </Section>
      <Section title='Укажите атрибуты' testId='administratorAttributes'>
        <FormCheckbox
          name='isTestData'
          label='Для тестирования'
          dataTestId='administratorFloorIsTestData'
        />
        <FormCheckbox
          name='isParking'
          label='Парковка'
          dataTestId='administratorFloorIsParking'
        />
      </Section>
    </>
  );
};
